import React from 'react'

// A route that React Router cannot match must never render an empty <main>.
// Until scripts/build-site.mjs emitted a shell per route, /privacy-policy was
// rewritten to /app and fell through to exactly that blank page.
const NotFoundPage: React.FC = () => (
  <div className="font-outfit text-ink-green-ink dark:text-ink-green-ink bg-ink-green-canvas dark:bg-ink-green-canvas min-h-screen">
    <section className="flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-32 pb-24">
      <div className="container mx-auto max-w-2xl text-center">
        <p className="text-xs sm:text-sm uppercase tracking-[.16em] text-ink-green-accent mb-4">
          Page not found
        </p>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-medium tracking-[-.03em] mb-4 leading-tight">
          That page isn&rsquo;t here.
        </h1>
        <p className="text-sm sm:text-base text-ink-green-ink-soft dark:text-ink-green-ink-soft leading-[1.55] mb-8">
          The address may have changed, or the link may be out of date.
        </p>
        <a
          href="/"
          className="inline-flex min-h-[44px] items-center text-sm font-medium underline decoration-1 underline-offset-[.24em] hover:text-ink-green-accent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink-green-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ink-green-canvas"
        >
          Back to novahass.partners
        </a>
      </div>
    </section>
  </div>
)

export default NotFoundPage
